import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import RequiredTwoFactorSetup from '@/pages/account/RequiredTwoFactorSetup';

const ProtectedRoute = ({ requireRole }) => {
    const { isAuthenticated, isLoading, currentUser } = useAuth();
    const location = useLocation();

    if (isLoading) return null;
    if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;
    if (currentUser?.twoFactorEnabled === false) return <RequiredTwoFactorSetup />;
    if (requireRole && currentUser?.role !== requireRole) return <Navigate to="/" replace />;

    return <Outlet />;
};

export default ProtectedRoute;
